import { parseFilename } from './files';
import axios from 'axios';
import { ATTENDANCE_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface AttendanceFiles {
  rosterFiles: File[];
  punchFiles: File[];
}

export interface AttendanceOptions {
  outputFilename?: string;
}

interface AttendanceOptionsPayload {
  output_filename?: string;
}

export interface AttendanceSummary {
  roster_rows: number;
  detailed_rows: number;
  employees: number;
  dates: number;
  log: string[];
}

export interface AttendanceResult {
  blob: Blob;
  filename: string;
  summary: AttendanceSummary | null;
}

export async function generateAttendanceReport(
  files: AttendanceFiles,
  options?: AttendanceOptions
): Promise<AttendanceResult> {
  const formData = new FormData();
  files.rosterFiles.forEach((file) => formData.append('roster_files', file));
  files.punchFiles.forEach((file) => formData.append('punch_files', file));

  const optionsPayload: AttendanceOptionsPayload = {};
  if (options?.outputFilename && options.outputFilename.trim()) {
    optionsPayload.output_filename = options.outputFilename.trim();
  }
  if (Object.keys(optionsPayload).length > 0) {
    formData.append('options', JSON.stringify(optionsPayload));
  }

  try {
    const response = await axios.post(
      `${ATTENDANCE_BASE_URL}/attendance/generate`,
      formData,
      { responseType: 'blob' }
    );

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      options?.outputFilename || 'Attendance_Report.xlsx'
    );
    const summaryHeader = response.headers['x-summary'];
    const summary = summaryHeader ? (JSON.parse(summaryHeader) as AttendanceSummary) : null;

    return { blob, filename, summary };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message =
        (data && data.detail) || `Attendance report generation failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
